<template>
  <t-form labelWidth="80px">
    <CptData :data="attribute.cptTableData" :cptDataForm="cptDataForm" />
    <e-collapse title="基础设置" :expand="true">
      <t-form-item label="文本">
        <t-input size="small" v-model="attribute.label" />
      </t-form-item>
      <t-form-item label="背景颜色">
        <t-color-picker
          size="small"
          :colorModes="['monochrome']"
          v-model="attribute.bgColor"
          format="RGBA"
          enableAlpha
        />
      </t-form-item>
    </e-collapse>
    <e-collapse title="字体设置" :expand="true">
      <t-form-item label="字体颜色">
        <t-color-picker
          size="small"
          :colorModes="['monochrome']"
          v-model="attribute.textColor"
          format="RGBA"
          enableAlpha
        />
      </t-form-item>
      <t-form-item label="字体样式">
        <t-radio-group size="small" v-model="attribute.fontStyle">
          <t-radio-button value="normal">正常</t-radio-button>
          <t-radio-button value="italic">斜体</t-radio-button>
        </t-radio-group>
      </t-form-item>
      <t-form-item label="加粗">
        <t-radio-group size="small" v-model="attribute.fontWeight">
          <t-radio-button value="normal">正常</t-radio-button>
          <t-radio-button value="bold">加粗</t-radio-button>
          <t-radio-button value="lighter">更细</t-radio-button>
        </t-radio-group>
      </t-form-item>
      <t-form-item label="字体">
        <t-select size="small" v-model="attribute.fontFamily">
          <t-option
            v-for="item in textFamilyList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </t-select>
      </t-form-item>
      <t-form-item label="字体大小">
        <t-input-number
          size="small"
          :decimal-places="0"
          :min="0"
          :max="9999"
          v-model="attribute.fontSize"
        />
      </t-form-item>
    </e-collapse>
    <e-collapse title="边框设置" :expand="true">
      <t-form-item label="边框宽度">
        <t-input-number
          size="small"
          v-model="attribute.borderSize"
          :decimal-places="0"
          :min="0"
          :max="9999"
        />
      </t-form-item>
      <t-form-item label="边框颜色">
        <t-color-picker
          size="small"
          :colorModes="['monochrome']"
          format="RGBA"
          enableAlpha
          v-model="attribute.borderColor"
        />
      </t-form-item>
      <t-form-item label="边框圆角">
        <t-input-number
          size="small"
          v-model="attribute.borderRadius"
          :decimal-places="0"
          :min="0"
          :max="9999"
        />
      </t-form-item>
      <t-form-item label="线条类型">
        <t-select size="small" v-model="attribute.lineType">
          <t-option
            v-for="item in lineTypeList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </t-select>
      </t-form-item>
    </e-collapse>
  </t-form>
</template>

<script>
import CptData from "@/components/element/options/comp/cpt-data";
export default {
  name: "cpt-map-navigator-option",
  props: {
    attribute: Object,
    cptDataForm: Object,
  },
  components: { CptData },
  created() {
    this.textFamilyList = require("@/assets/font/font-list");
    this.lineTypeList = require("@/assets/data/line-type");
  },
  data() {
    return {};
  },
};
</script>

<style scoped>
</style>